module.exports = __webpack_public_path__ + "img/애고미_이모티콘-28.5c34f9f.png";